export default __webpack_public_path__ + "static/media/info_portal_n.3667278e.svg";